import { DRAWER_TITLE_ID, Text, cn } from '@growtherapy/sprout-ui';

import {
  ClientInformationDrawerHeaderContentWrapper as ClientInformationDrawerHeaderConnected,
  ClientInformationDrawerHeaderContent,
} from '@grow-therapy-team/seedling-components';

import { DrawerHeaderWrapper as DrawerHeader } from '../../components/DrawerHeaderWrapper';
import { ParticipantStatus } from '../../types';

export type ClientInformationDrawerHeaderProps = {
  drawerTitle: string;
  visitorStatus?: ParticipantStatus;
  onClickBackButton?: () => void;
};

export function ClientInformationHeaderTitleBlock({
  drawerTitle,
  isScheduledClient,
}: {
  drawerTitle: string;
  isScheduledClient: boolean;
}) {
  return (
    <div className='flex flex-col'>
      <div className='flex flex-grow items-center'>
        <span
          className='fs-exclude'
          data-dd-privacy='mask'
          data-dd-action-name='Client Name'
          data-testid='client-information.header.name'
        >
          <Text
            as='span'
            variant={isScheduledClient ? 'lg' : 'md'}
            className={cn('flex flex-col', 'rebrand:typography-subhead-small rebrand:text-text-inverse', {
              'font-medium': isScheduledClient,
            })}
            id={DRAWER_TITLE_ID}
          >
            {drawerTitle}
          </Text>
        </span>
      </div>
    </div>
  );
}

export function ClientInformationDrawerHeader({
  drawerTitle,
  visitorStatus,
  onClickBackButton,
}: ClientInformationDrawerHeaderProps) {
  const isScheduledClient = visitorStatus === ParticipantStatus.SCHEDULED;
  const titleBlock = (
    <ClientInformationHeaderTitleBlock drawerTitle={drawerTitle} isScheduledClient={isScheduledClient} />
  );

  return (
    <DrawerHeader>
      {onClickBackButton ? (
        <ClientInformationDrawerHeaderContent
          // Seedling header uses items-start; self-center aligns the title with the back button.
          drawerTitle={<div className='self-center'>{titleBlock}</div>}
          onClickBackButton={onClickBackButton}
        />
      ) : (
        <ClientInformationDrawerHeaderConnected
          // Seedling header uses items-start; matching the close button's 40px box centers the two.
          drawerTitle={<div className='flex items-center arc:min-h-component-125'>{titleBlock}</div>}
        />
      )}
    </DrawerHeader>
  );
}
